import { render, staticRenderFns } from "./ModuleNotAvailable.vue?vue&type=template&id=748337c1&scoped=true"
import script from "./ModuleNotAvailable.vue?vue&type=script&lang=js"
export * from "./ModuleNotAvailable.vue?vue&type=script&lang=js"
import style0 from "./ModuleNotAvailable.vue?vue&type=style&index=0&id=748337c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748337c1",
  null
  
)

export default component.exports